export const BUTTON_CLICK = 'Button Clicked'
